import keyBy from 'lodash-es/keyBy';
import omit from 'lodash-es/omit';
import { BigCommerceActionTypes, BigCommerceApiKeys as keys, IBigCommerceStore } from '.';
import { IBigCommerceShipTypeMap } from './bigCommerceInterfaces';

export interface IBigCommerceState {
  shipMethodHash: { [index: number]: IBigCommerceShipTypeMap };
  storeHash: { [index: number]: IBigCommerceStore };
}

const initState: IBigCommerceState = {
  shipMethodHash: {},
  storeHash: {}
};

export function bigCommerceReducer(
  state: IBigCommerceState = initState,
  action: BigCommerceActionTypes
): IBigCommerceState {
  switch (action.type) {
    case keys.REMOVE_BIG_COMMERCE_SHIP_METHOD:
      return {
        ...state,
        shipMethodHash: omit(state.shipMethodHash, action.payload.bigCommerceShipTypeMapId)
      };
    case keys.REMOVE_BIG_COMMERCE_STORE:
      return {
        ...state,
        storeHash: omit(state.storeHash, action.payload.bigCommerceStoreId)
      };
    case keys.SET_BIG_COMMERCE_SHIP_METHODS:
      return {
        ...state,
        shipMethodHash: {
          ...state.shipMethodHash,
          ...keyBy(action.payload, (c: IBigCommerceShipTypeMap) => c.bigCommerceShipTypeMapId)
        }
      };
    case keys.SET_BIG_COMMERCE_STORES:
      return {
        ...state,
        storeHash: { ...state.storeHash, ...keyBy(action.payload, (c: IBigCommerceStore) => c.bigCommerceStoreId) }
      };
    default:
      return state;
  }
}
